import {
  Button,
  Icon,
  Menu,
  MenuTrigger,
  type PressEvent,
} from '@iconik-io/uad';

import { commentTypes } from '../../segment/constants';
import { CommentTypeMenuItem } from '../comment_type_menu_item/comment_type_menu_item';

type CommentTypeMenuProps = {
  onPress?: (event: PressEvent) => void;
  selectedKey: 'is_internal' | 'public';
  onSelectionChange?: (key: 'is_internal' | 'public' | null) => void;
};

export function CommentTypeMenu({
  onSelectionChange,
  onPress,
  selectedKey,
}: CommentTypeMenuProps) {
  const commentTypeItemsMapped = commentTypes.map((item) => ({
    id: item.value,
    element: (
      <CommentTypeMenuItem
        label={item.label}
        helpMessage={item.helpMessage}
        icon={item.icon}
      />
    ),
  }));

  const selectedItem = commentTypes.find((item) =>
    selectedKey ? selectedKey === item.value : undefined,
  );

  return (
    <MenuTrigger>
      <Button
        size="s"
        variant="tertiary"
        onPress={onPress}
        icon={
          selectedItem?.icon ? <Icon name={selectedItem?.icon} /> : undefined
        }
        aria-label="Comment type menu button"
      >
        {selectedItem?.label}
      </Button>
      <Menu
        items={commentTypeItemsMapped}
        selectionMode="single"
        selection={selectedKey}
        onSelectionChange={onSelectionChange}
      />
    </MenuTrigger>
  );
}
